import StaticInput from './StaticInput';

export default StaticInput;
